// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5490": "62e3d14e6ef0","5981": "9200fc8d30ac","6863": "454c9f289029","8990": "7d69c8cdd354",}[chunkId] + ".css"
}